import { Phone, Mail, MapPin } from "lucide-react";
import Reveal from "@/components/Reveal";
import SectionHeader from "@/components/SectionHeader";

const Contact = () => (
  <section id="contact" className="bg-white py-20 sm:py-24" data-testid="contact-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        align="center"
        eyebrow="Get In Touch"
        title="Contact Glow & Shine Sisters"
        subtitle="We would love to hear from you. Reach out today for a free, friendly quote."
      />

      <div className="mx-auto mt-14 grid max-w-4xl gap-6 sm:grid-cols-3">
        <Reveal>
          <a
            href="tel:+18563080562"
            data-testid="contact-phone-card"
            className="flex h-full flex-col items-center rounded-2xl border border-[#8E7CC3]/15 bg-[#FAF8FF] p-8 text-center shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-all duration-300 hover:-translate-y-1 hover:border-[#D4AF37]/40"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#E6E6FA]">
              <Phone className="h-5 w-5 text-[#674EA7]" aria-hidden="true" />
            </span>
            <p className="mt-5 text-xs font-semibold uppercase tracking-widest text-[#6B6776]">Call Us</p>
            <p className="mt-2 text-base font-bold text-[#2C2A35]">+1 (856) 308-0562</p>
          </a>
        </Reveal>
        <Reveal delay={0.1}>
          <a
            href="mailto:Glowandshinesisterscleaningco@gmail.com"
            data-testid="contact-email-card"
            className="flex h-full flex-col items-center rounded-2xl border border-[#8E7CC3]/15 bg-[#FAF8FF] p-8 text-center shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-all duration-300 hover:-translate-y-1 hover:border-[#D4AF37]/40"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#E6E6FA]">
              <Mail className="h-5 w-5 text-[#674EA7]" aria-hidden="true" />
            </span>
            <p className="mt-5 text-xs font-semibold uppercase tracking-widest text-[#6B6776]">Email Us</p>
            <p className="mt-2 break-all text-sm font-bold text-[#2C2A35]">Glowandshinesisterscleaningco@gmail.com</p>
          </a>
        </Reveal>
        <Reveal delay={0.2}>
          <div
            className="flex h-full flex-col items-center rounded-2xl border border-[#8E7CC3]/15 bg-[#FAF8FF] p-8 text-center shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
            data-testid="contact-area-card"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[#E6E6FA]">
              <MapPin className="h-5 w-5 text-[#674EA7]" aria-hidden="true" />
            </span>
            <p className="mt-5 text-xs font-semibold uppercase tracking-widest text-[#6B6776]">Service Area</p>
            <p className="mt-2 text-sm font-bold text-[#2C2A35]">Camden, NJ &amp; surrounding South Jersey areas</p>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.15} className="mt-12 flex flex-col items-center justify-center gap-4 sm:flex-row">
        <a
          href="tel:+18563080562"
          data-testid="contact-call-now-button"
          className="w-full rounded-full bg-[#8E7CC3] px-8 py-4 text-center text-sm font-bold uppercase tracking-wider text-white shadow-[0_8px_30px_rgb(142,124,195,0.35)] transition-transform hover:scale-[1.02] sm:w-auto"
        >
          Call Now
        </a>
        <a
          href="mailto:Glowandshinesisterscleaningco@gmail.com"
          data-testid="contact-email-us-button"
          className="w-full rounded-full border-2 border-[#8E7CC3]/40 bg-white px-8 py-4 text-center text-sm font-bold uppercase tracking-wider text-[#674EA7] transition-transform hover:scale-[1.02] sm:w-auto"
        >
          Email Us
        </a>
        <a
          href="#quote"
          data-testid="contact-quote-button"
          className="w-full rounded-full border-2 border-[#D4AF37]/60 bg-white px-8 py-4 text-center text-sm font-bold uppercase tracking-wider text-[#2C2A35] transition-transform hover:scale-[1.02] sm:w-auto"
        >
          Request a Free Quote
        </a>
      </Reveal>
    </div>
  </section>
);

export default Contact;
